<script>
    import {fade} from 'svelte/transition';
    import R, {LOADER} from "../lib/requests";
    import passportsStore from "../stores/passportsStore";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import {passportsArray} from "../lib/lib";
    import {PASSPORT_STATUS} from "../lib/constants";

    export let passports = null;
    export let completeCallback = null;

    let loading = false;
    let error = null;
    let errorStatus = null;
    let passportChunks = null;
    let chunkIndex = 0;
    let checkResult = { // result of check passports action
        assigned: [],
        returned: [],
        destroyed: [],
        fail: [],
    };
    let progress = 0;

    const login = () => {
        const onSuccess = result => {
            loading = null;
            $passportsStore.token = result;
        }

        const onFailure = err => {
            loading = null;
            error = '';
            if (err.params) {
                errorStatus = err.params.status;
                if (err.params.code) {
                    error = `Κωδικός: ${err.params.code}`;
                }
                error += (error ? "<br>" : "") + err.params.description;
            } else {
                error = err.message;
            }
        };

        error = null;
        errorStatus = '';
        loading = 'Σύνδεση με διακομιστή διαβατηρίων';
        R.handle(R.passport.apiLogin, {}, onSuccess, onFailure, LOADER.NONE);
    }

    const sendPassportChunks = () => {
        let arr = passportsArray(passports.passport_from, passports.passport_to);

        passportChunks = [];
        let chunk = [];
        arr.map(item => {
            chunk.push(item);
            if (chunk.length === 25) {
                passportChunks.push(chunk);
                chunk = [];
            }
        });

        if (chunk.length) {
            passportChunks.push(chunk);
        }

        chunkIndex = 0;
        checkRequest();
    }

    const checkRequest = () => {
        const onSuccess = result => {
            if (result.success.length) {
                result.success.map(item => {
                    if (checkResult[item.statusdescription]) {
                        checkResult[item.statusdescription].push({passport:item.passport, vat:item.vetassignedvat})
                    }
                });
            }

            if (result.fail && result.fail.length > 0) {
                checkResult.fail = checkResult.fail.concat(result.fail);
            }

            if (chunkIndex < passportChunks.length - 1) {
                chunkIndex++;
                checkRequest();
            } else {
                loading = null;
                close(checkResult);
            }
        }

        const onFailure = err => {
            error = "Παρουσιάστηκε σφάλμα κατά την εξυπηρέτηση του αιτήματος!";
            if (err.params) {
                if (err.params.status) {
                    errorStatus = err.params.status
                }
                if (err.params.message) {
                    error+= `<br>${err.params.message}`;
                }
            }
            loading = false;
        };

        let totalPassports = 0;
        let currentPassports = 0;
        let index = 0;
        passportChunks.map(item => {
            totalPassports += item.length;
            if (index <= chunkIndex) {
                currentPassports += item.length;
            }
            index++;
        });

        progress = (100 * currentPassports) / totalPassports;
        if (progress > 100) progress = 100;

        error = null;
        errorStatus = '';
        loading = `Έλεγχος ${totalPassports} διαβατηρίων`;
        let data = {
            token: $passportsStore.token,
            action: PASSPORT_STATUS.CHECK,
            passports: passportChunks[chunkIndex]
        };

        R.handle(R.passport.apiRequest, data, onSuccess, onFailure, LOADER.NONE);
    }

    const close = (params) => {
        if (loading) {
            return;
        }

        passports = null;

        setTimeout(() => {
            completeCallback(params);
        }, 200);
    }

    $: if (passports) {
        if (!$passportsStore.token && !error) {
            login();
        } else {
            if (!passportChunks) {
                sendPassportChunks();
            }
        }
    }
</script>
{#if passports}
    <div class="passport-check-overlay" transition:fade="{{ duration: 100 }}">
        <div class="passport-check-box">
            <div class="close" on:click={ () => close() }>&times;</div>
            <div class="icon">
                <AppIcon icon="passport" size="100"/>
            </div>
            <div class="content">
                {#if loading}
                    <div class="loading mb-2">
                        {@html loading }
                    </div>
                    <div class="progress" role="progressbar" aria-valuenow="{ progress }"
                         aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style="width: { progress }%"></div>
                    </div>
                {:else if error}
                    <h6 class="text-danger mb-2">Σφάλμα { errorStatus }</h6>
                    {@html error }
                    <button class="btn btn-link py-0 mt-2" on:click={ () => close() }>Κλείσιμο</button>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .passport-check-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9910;
        background: rgba(0, 0, 0, 0.5);
    }

    .passport-check-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 450px;
        max-width: 100%;
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        -webkit-box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        -moz-box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        padding: 25px;

    }

    .passport-check-box .close {
        position: absolute;
        top: 0;
        right: 6px;
        font-size: 30px;
        cursor: pointer;
        padding: 5px;
        line-height: 1;
    }

    .passport-check-box .icon {
        color: #737373;
    }

    .passport-check-box .content {
        position: relative;
        width: calc(100% - 60px);
        text-align: center;
        padding-left: 15px;
    }

    .passport-check-box .content .loading {
        margin-bottom: 4px;
    }
</style>
